import QuickOption from "./components/Quick Option/QuickOption";
import { Container, Row } from "reactstrap";
import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Asessment from "./components/Asessment";
import Profil from "./components/Profil";
import RekapAbsen from "./components/RekapAbsen";
import Pengumuman from "./components/Pengumuman/Pengumuman";
import { FEATURE_SELECTION } from "../../Constant/FeatureSelection";
import { useDashboard } from "../../Context/DashboardContext";

const DefaultContain = () => {
  const dashboardAPI = useDashboard();
  const [dataStaf, setDataStaf] = useState([]);
  const idStaf = localStorage.getItem("staf_id");

  let isMounted = true;
  useEffect(() => {
    const username = localStorage.getItem("username");
    
    if (username === null) {
      localStorage.removeItem("authTokens");
      <Navigate to="/signin" />;
    }

    
    fetchData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  const fetchData = async () => {
    const stafRes = await dashboardAPI.getStafByID(idStaf);
    const stafData = stafRes.data;
    setDataStaf(stafData);
  };

  return (
    <Fragment>
      <Container fluid={true} className="default-dash">
        <Row>
          {FEATURE_SELECTION.includes("Asesmen") && <Asessment xs="12" className="box-col dash-chat" />}
          <QuickOption xs="12" className="box-col dash-chat" dataStaf={dataStaf} />
          <Profil
            xl="4"
            lg="12"
            md="6"
            className="des-md-50 des-xl-50 xl-50 box-col-6"
            dataStaf={dataStaf}
          />
          <Pengumuman
            xl="8"
            lg="12"
            md="6"
            className="des-md-50 des-xl-50 xl-50 box-col-6"
          />
          <RekapAbsen xs="12" className="box-col dash-chat" />
        </Row>
      </Container>
    </Fragment>
  );
};
export default DefaultContain;
